import * as React from 'react';
import { SVGProps } from 'react';

const IcNone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    fill="none"
    {...props}
  >
    <rect width={24} height={24} x={0.667} fill="#E4FFE7" rx={12} />
    <path
      fill="#1B5F1F"
      fillRule="evenodd"
      d="M12.667 20.5a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm4.53-10.47a.75.75 0 1 0-1.06-1.06l-4.97 4.97-1.97-1.97a.75.75 0 0 0-1.06 1.06l2.5 2.5a.75.75 0 0 0 1.06 0l5.5-5.5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default IcNone;
